import { createSlice } from "@reduxjs/toolkit";

const initialState = { cache: {} };

const selectInputCacheSlice = createSlice({
  name: "selectInputCache",
  initialState,
  reducers: {
    upsertItems(state, action) {
      state.cache[action.payload.tipoItem] = action.payload.items;
    },
    reset(state) {
      state.cache = {};
    },
  },
});

export const selectInputCacheActions = selectInputCacheSlice.actions;

export default selectInputCacheSlice.reducer;
